import { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
//import "./UserForm.css";
import PageContainer from "components/PageContainer/PageContainer";
import { useParams } from "react-router-dom";
import BasicDetailsTab from "./BasicDetailsTab";
import PermissionsTab from "./PermissionTab";

const UserForm = (props: any) => {
  const [activeTab, setActiveTab] = useState("basic");
  const { id } = useParams<{ id: string }>();
  const user_id = id || "";
  const isEdit = Boolean(user_id);
  
  // State to track permission user ID from localStorage
  const [permissionUserId, setPermissionUserId] = useState<string | null>(null);
  
  // Check if there's a newly created user in localStorage
  const getPermissionUserId = () => {
    const permissionUser = localStorage.getItem("permission_user");
    if (permissionUser) {
      try {
        const parsed = JSON.parse(permissionUser);
        return parsed || permissionUser;
      } catch {
        return permissionUser;
      }
    }
    return null;
  };
  
  // Update permissionUserId when activeTab changes or component mounts
  useEffect(() => {
    const userId = getPermissionUserId();
    setPermissionUserId(userId);
  }, [activeTab]);
  
  const hasUser = isEdit || Boolean(permissionUserId);
  const effectiveUserId = user_id || permissionUserId || "";
  
  const renderContent = () => {
    console.log(`active tab: ${activeTab}`);
    switch (activeTab) {
      case "basic":
        return <BasicDetailsTab setActiveTab={setActiveTab} isEdit={isEdit} user_id={user_id} />;
      case "permissions":
        // Guard: don't render permissions UI when creating a new user (and no user in localStorage)
        if (!hasUser) {
          return (
            <div className="alert alert-info mt-3">
              Permissions are available after creating the user. Save basic details to enable permissions.
            </div>
          );
        }
        return <PermissionsTab id={effectiveUserId} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    // Only switch to permissions tab from outside when editing an existing user
    if (props?.page !== undefined && isEdit) {
      setActiveTab("permissions");
    }
  }, [props, isEdit]);

  return (
    <PageContainer>
        <Nav
          variant="tabs"
          activeKey={activeTab}
          onSelect={(selectedKey: any) => {
            if (!selectedKey) return;
            // prevent switching to permissions when creating a new user (and no user in localStorage)
            if (selectedKey === "permissions" && !hasUser) return;
            setActiveTab(selectedKey);
          }}
        >
          <Nav.Item>
            <Nav.Link
              eventKey="basic"
              className={`fw-semibold ${activeTab === "basic"
                  ? "text-primary border-bottom border-primary"
                  : "text-muted"
                }`}
            >
              Basic Details
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="permissions"
              disabled={!hasUser}
              title={!hasUser ? "Complete basic details to enable permissions" : undefined}
              className={`fw-semibold ${activeTab === "permissions"
                  ? "text-primary border-bottom border-primary"
                  : "text-muted"
                } ${!hasUser ? "disabled" : ""}`}
            >
              Permissions
            </Nav.Link>
          </Nav.Item>
        </Nav>


        {renderContent()}
    </PageContainer>
  );
};

export default UserForm;
